/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Volumen del botón "Marcar"',
  ringtoneVolume: 'Volumen del tono de llamada',
  callVolume: 'Volumen de llamadas',
  muteCalls: 'Silenciar llamadas',
  outputDevice: 'Dispositivo de salida',
  inputDevice: 'Dispositivo de entrada',
  micPermission: 'Permiso para el micrófono',
  noDevice: 'Sin dispositivo',
  checkMicPermission: 'Comprobar permiso',
  micNoPermissionMessage:
    'La aplicación no tiene permiso para utilizar el micrófono',
  noLabel: 'Dispositivo desconocido',
  notSetSinkIdTip:
    'Los permisos de su navegador actual no están configurados para que podamos acceder a sus dispositivos de salida de audio.{clickHereLink}para ver cómo configurarlos.',
  noLabelTip:
    'Los permisos de su navegador actual no están configurados para que podamos acceder a sus dispositivos de entrada de audio.',
  clickHere: 'Haga clic aquí',
  defaultOutputDevice: 'Dispositivo de salida predeterminado',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
